import React from 'react';
import Slider from 'react-slick';
import Box from '@mui/material/Box';

function Save({ widgetStyle, widgetProps }) {
    return (
        <Box sx={[widgetStyle ?? {}, {minHeight: '100px'}]} className="slider-container">
            <Slider
                arrows={false}
                dots={false}
                infinite={widgetProps.infinite ?? true}
                speed={widgetProps.speed ?? 300}
                slidesToShow={widgetProps.slidesToShow ?? 1}
                slidesToScroll={widgetProps.slidesToScroll ?? 1}
                autoplay={widgetProps.autoplay ?? true}
                autoplaySpeed={widgetProps.autoplaySpeed ?? 5000}
                cssEase={'linear'}
            >
                {
                    widgetProps?.imageUrl?.map((image, imageIndex) => (
                        <Box key={imageIndex} sx={{height: widgetProps.containerHeight ?? 200, width: '100%'}}>
                            <Box component={'img'} src={image} sx={{ objectFit: 'contain', height: 1, width: 1 }} />
                        </Box>
                    ))
                }
            </Slider>
        </Box>
    )
}

export default React.memo(Save);